module.exports = __webpack_public_path__ + "img/map.22f6d2f8.png";